// components/admin/content-management/sections/display/image-section-display.component.jsx

import { useContext, useEffect, useState } from 'react';

import ImageGallery from '../../../../reusable/images/image-gallery/image-gallery.component.jsx';
import AddImage from '../../../../reusable/images/add-image/add-image.component.jsx';
import ComponentModal from '../../../../reusable/component-modal/component-modal.component.jsx';
import Spinner from '../../../../reusable/spinner/spinner.component.jsx';
import Button from '../../../../reusable/button/button.component.jsx';

import { ToastContext } from '../../../../../contexts/toast.context.jsx';

import Client from '../../../../../tools/client.js';

import {
  Container,
  HeaderRow,
  Title,
  ActionButton,
  Message
} from './image-display.styles.jsx';

const client = new Client();

const ImageSectionDisplay = ({ section, getSection = async () => {} }) => {
  const [loading, setLoading] = useState(true);
  const [images, setImages] = useState([]);
  const [image, setImage] = useState(null);
  const [showAddModal, setShowAddModal] = useState(false);

  const { errorToast, successToast } = useContext(ToastContext);

  useEffect(() => {
    if(section.Images.length > 0) {
      setImages(section.Images);
      setImage(section.Images[0]);
    }
    setLoading(false);
  }, []);

  const saveImage = async (file) => {
    let formData = new FormData();
    formData.append('files', file);

    const res = await client.addSectionImages(section.id, formData);
    if (res?.status === 200) {
      successToast('Image uploaded successfully');
      await getSection();
      setShowAddModal(false);
    } else {
      errorToast('Failed to upload image');
    }
  };

  const handleDeleteImage = async (id) => {
    const res = await client.deleteSectionImage(section.id, id);

    if (res?.status === 200) {
      successToast('Image deleted');
      await getSection();
    } else {
      errorToast('Failed to delete image');
    }
  };

  return (
    <Container>
      <ComponentModal
        isOpen={showAddModal}
        onClose={() => setShowAddModal(false)}
        title="Upload Image"
      >
        <AddImage
          image={image}
          setImage={setImage}
          saveImage={saveImage}
          showSaveButton={true}
        />
      </ComponentModal>

      <HeaderRow>
        <Title>Image Section</Title>
        <ActionButton onClick={() => setShowAddModal(true)}>Add Image</ActionButton>
      </HeaderRow>

      {loading ? (
        <Spinner />
      ) : images.length > 0 ? (
        <ImageGallery images={images} onDelete={handleDeleteImage} />
      ) : (
        <Message>No images have been added to this section.</Message>
      )}
    </Container>
  );
};

export default ImageSectionDisplay;